'use client'

import { useTheme } from 'next-themes'
import { Toaster as Sonner, toast, type ToasterProps } from 'sonner'

const Toaster = ({ style, ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': '0.5px solid var(--border)',
          fontFamily: 'inherit',
          ...style
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster, toast }
